<template>
  <section :class="$options.name">
    <div class="hero-quad__grid">
      <div v-for="(quad, i) in cells"
        :key="i"
        class="hero-quad__cell"
        @mouseenter="active = i"
        @mouseleave="active = null"
        @click="onCellClick(quad)">
        <div class="hero-quad__bg"
          :style="{ backgroundImage: 'url(' + quad.bgImg + ')' }" />
        <div class="hero-quad__overlay" />
        <div class="hero-quad__content">
          <div class="hero-quad__icons">
            <i v-for="(icon, j) in quad.icons"
              :key="j"
              :class="iconClass(icon)" />
          </div>
          <span>{{ quad.title }}</span>
        </div>
      </div>
    </div>

    <div class="hero-quad__circle overlay-loader"
      @click="$emit('open-contact')">
      <img src="/img/logo-tekstiga-valge.png"
        alt="Aktuaalne" />
    </div>
  </section>
</template>

<script>
const defaultBgs = ['/img/slide1.jpg', '/img/slide2.jpg', '/img/slide3.jpg', '/img/slide4.jpg']

export default {
  name: 'hero-quad',
  props: {
    services: {
      type: Array,
      default: () => []
    }
  },
  emits: ['open-service', 'ready', 'open-contact'],
  data() {
    return {
      active: null
    }
  },
  computed: {
    cells() {
      const items = this.services.map((s, i) => ({
        bgImg: s.bgImg || defaultBgs[i % defaultBgs.length],
        icons: s.icon ? s.icon.split(',') : [],
        title: s.title || '',
        service: s
      }))
      items.push({
        bgImg: defaultBgs[items.length % defaultBgs.length],
        icons: ['fa-solid fa-cart-shopping'],
        title: 'E-Pood',
        href: '/pood'
      })
      return items
    }
  },
  watch: {
    cells: {
      immediate: true,
      handler(list) {
        if (!list.length || !this.services.length) return
        const urls = [...list.map(c => c.bgImg), '/img/A-valge.png']
        Promise.all(urls.map(u => new Promise(res => {
          const img = new Image()
          img.onload = img.onerror = res
          img.src = u
        }))).then(() => this.$emit('ready'))
      }
    }
  },
  methods: {
    iconClass(icon) {
      return icon.startsWith('fa-') ? icon : 'fa-solid fa-' + icon
    },
    onCellClick(quad) {
      if (quad.href) {
        this.$router.push(quad.href)
      } else if (quad.service) {
        this.$emit('open-service', quad.service)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-quad {
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

.hero-quad__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  height: 100%;
}

.hero-quad__cell {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
}

.hero-quad__bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.6s ease;
}

.hero-quad__overlay {
  position: absolute;
  inset: 0;
  background: rgba(30, 30, 30, 0.75);
  transition: background 0.4s ease;
}

.hero-quad__cell:hover .hero-quad__bg {
  transform: scale(1.05);
}

.hero-quad__cell:hover .hero-quad__overlay {
  background: rgba(30, 30, 30, 0.3);
}

.hero-quad__content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-shadow: 0 2rem 8rem rgba(0, 0, 0, 0.5);
  gap: 16rem;
  transition: opacity 0.3s ease;

  span {
    font-size: 22rem;
    font-weight: 700;
    letter-spacing: 0.5rem;
  }
}

.hero-quad__icons {
  display: flex;
  gap: 16rem;

  i {
    font-size: 26rem;
  }

  span {
    font-size: 18rem;
    font-weight: 700;
    letter-spacing: 0.5rem;
  }
}

.hero-quad__circle {
  position: absolute;
  inset: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  width: 200rem;
  height: 200rem;
  border-radius: 50%;
  backdrop-filter: blur(12rem);
  box-shadow: 0 8rem 40rem rgba(0, 0, 0, 0.3);
  pointer-events: auto;
  cursor: pointer;
  transition: transform 0.4s ease, box-shadow 0.4s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.08);
    box-shadow: 0 12rem 50rem rgba(0, 0, 0, 0.45);
  }

  img {
    width: 170rem;
    object-fit: contain;
    animation: none;
  }
}

@include max-screen(640) {
  .hero-quad__grid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }

  .hero-quad__circle {
    width: 160rem;
    height: 160rem;

    img {
      width: 130rem;
    }
  }

  .hero-quad__content {
    gap: 8rem;

    i {
      font-size: 18rem;
    }

    span {
      font-size: 14rem;
    }
  }

  .hero-quad__icons {
    gap: 10rem;
  }
}
</style>
